const value = {
    correct: 'Верный ответ',
    option: 'Вариант',
    correctAnswersQuizCount: 'Правильных ответов на квиз',
    correctAnswersPracticeCount: 'Выполненных заданий',
    correctAnswersTotalCount: 'Общий счет',
    successResultsTitle: 'Поздравляем',
    successResultsSubTitle: 'Вы успешно выполнили задание',
    successResultsMessage: 'Чемпион по безопасности - это про вас',
    failResultsTitle: 'К сожалению вы не справились с заданием',
    failResultsMessage: 'Мы рекомендуем вам внимательно изучить теорию и повторить попытку',
    resultSuccessTitle: 'Молодец, вы достигли высоких результатов!',
    resultSuccessSubtitle: 'Отличная работа, продолжайте в том же духе!',
    resultOkTitle: 'Хороший результат! Вы ответили на большинство вопросов правильно.',
    resultOkSubtitle:
      'Перед следующим прохождением обратите внимание на вопросы, в которых допустили ошибки, и изучите юнит еще раз.',
    resultFailureTitle: 'Попробуйте еще раз, у вас недостаточно верных ответов, чтобы сдать юнит.',
    resultFailureSubtitle:
      'Обратите внимание на вопросы, проанализируйте их и изучите проблемные области. Пройдите квиз/практику еще раз, чтобы проверить, что понимаете все правильно.',
    success: 'Успешно',
    successMessage: 'Вы выполнил все задания правильно или допустил одну ошибку',
    neutral: 'Нейтрально',
    neutralMessage: 'Допущено более одной ошибки и более 50% ответов отвечено верно',
    failure: 'Провал',
    failureMessage: 'Допущено более 50% неверных ответоввал',
    quizResultMessage: '{{title}} Вы ответили на {{correctAnswers}} из {{totalQuestions}} вопросов и заработали',
  };

export default value;
